import { boolean, number, object, string } from "yup";
import type { CompanyProcessValues } from "@companyProcess/types/companyProcess";

const companyProcessValidationSchema = object<CompanyProcessValues>({
    empresaId: number().required().min(1, 'Por favor seleccione una empresa valida'),
    nombre:  string().required(),
    horaInicio: string().required('Por favor seleccione una hora de inicio'),
    horaFin: string().required('Por favor seleccione una hora final'),
    lunes: boolean(),
    martes: boolean(),
    miercoles: boolean(),
    jueves: boolean(),
    viernes: boolean(),
    sabado: boolean(),
    domingo: boolean(),
    activo: boolean(),
})

export default companyProcessValidationSchema